import { set } from "dot-object";
import { useMemo } from "react";
import {
  deleteEmbedProp,
  updateEmbedProp,
} from "legacy/actions/embeddingActions";

import { getEmbedPropById } from "legacy/selectors/sagaSelectors";
import { mergeUpdatesWithBindingsOrTriggers } from "legacy/utils/DynamicBindingUtils";
import { useAppSelector } from "store/helpers";
import { Flag } from "store/slices/featureFlags";
import { fastClone } from "utils/clone";
import { NOOP } from "utils/function";
import { EMBED_PROP_PROPERTIES } from "../../Explorer/Embedding/EmbeddingProperties";
import { ItemTypeNonWidget } from "../ItemKindConstants";
import type { ItemKinds } from "../ItemKindConstants";
import type { ItemKindAccessor } from "../ItemKinds";
import type { ApplicationScope } from "@superblocksteam/shared";
import type { EmbedProperty } from "legacy/constants/EmbeddingConstants";
import type { Dispatch } from "redux";
import type { Flags } from "store/slices/featureFlags";

export const EmbedPropAccessor: ItemKindAccessor<ItemKinds.EMBED_PROP> = {
  useItemName: (itemProperties) =>
    useMemo(() => {
      return {
        name: itemProperties.name,
        editable: true,
        requiresValidation: true,
      };
    }, [itemProperties.name]),
  itemType: (itemProperties) => ItemTypeNonWidget.EMBED_PROP,
  useItemProperties: (itemId: string) => {
    return useAppSelector((state) => getEmbedPropById(state, itemId));
  },
  updateItemProperties: (
    dispatch: Dispatch,
    properties: EmbedProperty,
    updates: Record<string, unknown>,
    itemScope: ApplicationScope,
    flags: Flags,
  ) => {
    const changes: EmbedProperty = fastClone(properties);

    const updatesWithBindings = mergeUpdatesWithBindingsOrTriggers(
      properties,
      EMBED_PROP_PROPERTIES,
      updates,
      flags[Flag.ENABLE_DEEP_BINDINGS_PATHS],
    );
    for (const [key, value] of Object.entries(updatesWithBindings)) {
      set(key, value, changes);
    }
    dispatch(updateEmbedProp({ [properties.id]: changes }));
  },
  deleteItemProperties: NOOP,
  deleteItem: (dispatch, embedPropId) => {
    dispatch(deleteEmbedProp(embedPropId));
  },
  icon: () => null,
};
